import React from 'react';
import styled from 'styled-components';
import ImageGallery from './ImageGallery';
import maqRsuImg from '../assets/images/maq-rsu.jpeg';
import maq1Img from '../assets/images/maq-1.jpeg';
import maqImg from '../assets/images/maq.jpeg';
import separacaoImg from '../assets/images/separacao.jpeg';
import arteMaqRsu from '../assets/images/Arte-para-maq-rsu.png';

const Section = styled.section`
  padding: 8rem 1rem 4rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
`;

const Description = styled.p`
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3rem;
  line-height: 1.6;
  color: #666;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
`;

const FeatureCard = styled.div`
  padding: 1.5rem;
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
`;

const FeatureDescription = styled.p`
  color: #666;
  line-height: 1.5;
`;

const ProcessSection = styled.div`
  margin: 4rem 0;
`;

const ProcessTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
`;

const ProcessSteps = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
`;

const ProcessStep = styled.div`
  text-align: center;
  padding: 1.5rem;
`;

const StepNumber = styled.div`
  width: 40px;
  height: 40px;
  background: #4CAF50;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-weight: bold;
`;

const StepTitle = styled.h4`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  color: #333;
`;

const StepDescription = styled.p`
  color: #666;
  line-height: 1.5;
`;

const SpecsSection = styled.div`
  margin: 4rem 0;
  background: #f9f9f9;
  padding: 2rem;
  border-radius: 8px;
`;

const SpecsTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
`;

const SpecsList = styled.ul`
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
`;

const SpecItem = styled.li`
  padding: 0.5rem 0;
  color: #666;
  &:before {
    content: "•";
    color: #4CAF50;
    font-weight: bold;
    margin-right: 0.5rem;
  }
`;

const ComplianceSection = styled.div`
  margin: 4rem 0;
`;

const ComplianceTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
`;

const ComplianceList = styled.ul`
  list-style: none;
  padding: 0;
`;

const ComplianceItem = styled.li`
  padding: 1rem;
  margin-bottom: 1rem;
  background: #f9f9f9;
  border-radius: 4px;
  color: #666;
  &:before {
    content: "✓";
    color: #4CAF50;
    margin-right: 0.5rem;
  }
`;

const maqRsuImages = [
  {
    url: maqRsuImg,
    caption: "Sistema MAQ-RSU - Planta de Processamento"
  },
  {
    url: maq1Img,
    caption: "Sistema Automatizado de Triagem"
  },
  {
    url: maqImg,
    caption: "Tratamento Térmico de Resíduos"
  },
  {
    url: separacaoImg,
    caption: "Sistema de Tratamento e Separação"
  },
  {
    url: arteMaqRsu,
    caption: "Produtos Sustentáveis - Pavers e Tijolos Ecológicos"
  }
];

const processImages = [
  {
    url: maq1Img,
    caption: "Preparação e Abastecimento Automatizado"
  },
  {
    url: maqImg,
    caption: "Sistema de Condução e Processamento"
  },
  {
    url: maqRsuImg,
    caption: "Câmara de Combustão Controlada"
  }
];

const MaqRsu = () => {
  return (
    <Section>
      <Title>Sistema MAQ-RSU</Title>
      <Description>
        Sistema automatizado de última geração para tratamento térmico de rejeitos, desenvolvido com tecnologia verde própria 
        e foco na redução significativa do volume de resíduos, atendendo aos mais rigorosos padrões ambientais.
      </Description>

      <ImageGallery 
        title="Tecnologia de Ponta em Tratamento de Resíduos" 
        images={maqRsuImages} 
      />

      <FeaturesGrid>
        <FeatureCard>
          <FeatureTitle>Tecnologia Verde</FeatureTitle>
          <FeatureDescription>
            Tecnologia multidisciplinar própria, com baixo consumo de combustível fóssil e aplicação de tratamentos 
            físico-químicos sustentáveis.
          </FeatureDescription>
        </FeatureCard>
        <FeatureCard>
          <FeatureTitle>Automação Avançada</FeatureTitle>
          <FeatureDescription>
            Operação automatizada com código fonte próprio, controle local e monitoramento remoto, permitindo ajustes 
            automáticos instantâneos.
          </FeatureDescription>
        </FeatureCard>
        <FeatureCard>
          <FeatureTitle>Alta Eficiência</FeatureTitle>
          <FeatureDescription>
            Redução de até 95% do volume e massa dos resíduos, com aproveitamento dos próprios resíduos como fonte 
            de calor e energia.
          </FeatureDescription>
        </FeatureCard>
      </FeaturesGrid>

      <ProcessSection>
        <ProcessTitle>Processo de Funcionamento</ProcessTitle>
        
        <ImageGallery 
          title="Etapas do Processo" 
          images={processImages} 
        />

        <ProcessSteps>
          <ProcessStep>
            <StepNumber>1</StepNumber>
            <StepTitle>Preparação</StepTitle>
            <StepDescription>
              O rejeito é preparado e inserido na bandeja receptora de abastecimento automatizado.
            </StepDescription>
          </ProcessStep>
          <ProcessStep>
            <StepNumber>2</StepNumber>
            <StepTitle>Condução</StepTitle>
            <StepDescription>
              Os rejeitos são conduzidos dentro da calha, passando pelo duto hermético até a câmara de combustão.
            </StepDescription>
          </ProcessStep>
          <ProcessStep>
            <StepNumber>3</StepNumber>
            <StepTitle>Combustão</StepTitle>
            <StepDescription>
              Ocorre a combustão completa a 850°C, com sistema automatizado e seguro.
            </StepDescription>
          </ProcessStep>
          <ProcessStep>
            <StepNumber>4</StepNumber>
            <StepTitle>Tratamento</StepTitle>
            <StepDescription>
              Os gases passam por 6 níveis de tratamento em sistema fechado antes da liberação.
            </StepDescription>
          </ProcessStep>
          <ProcessStep>
            <StepNumber>5</StepNumber>
            <StepTitle>Aproveitamento</StepTitle>
            <StepDescription>
              As cinzas são resfriadas e preparadas para fabricação de pavers e tijolos ecológicos.
            </StepDescription>
          </ProcessStep>
        </ProcessSteps>
      </ProcessSection>

      <SpecsSection>
        <SpecsTitle>Especificações Técnicas</SpecsTitle>
        <SpecsList>
          <SpecItem>Temperatura de operação: 850°C</SpecItem>
          <SpecItem>6 níveis de tratamento de gases</SpecItem>
          <SpecItem>Sistema de monitoramento remoto</SpecItem>
          <SpecItem>Controle automatizado de processos</SpecItem>
          <SpecItem>Baixo consumo de combustível fóssil</SpecItem>
          <SpecItem>Redução de até 95% do volume</SpecItem>
          <SpecItem>Sistema hermético de segurança</SpecItem>
          <SpecItem>Aproveitamento energético</SpecItem>
        </SpecsList>
      </SpecsSection>

      <ComplianceSection>
        <ComplianceTitle>Conformidade com Legislações</ComplianceTitle>
        <ComplianceList>
          <ComplianceItem>
            Lei Federal 12.305/2010 - Política Nacional dos Resíduos Sólidos (PNRS)
          </ComplianceItem>
          <ComplianceItem>
            Resolução CONAMA nº 316/2002 - Controle e emissão dos gases
          </ComplianceItem>
          <ComplianceItem>
            Lei Nº 14.026/2020 - Marco do Saneamento Básico
          </ComplianceItem>
          <ComplianceItem>
            Lei Nº 9.605/1998 - Sanções penais e administrativas para atividades lesivas ao meio ambiente
          </ComplianceItem>
        </ComplianceList>
      </ComplianceSection>
    </Section>
  );
};

export default MaqRsu;
